module.exports = __webpack_public_path__ + "img/slide-3.733c355d.jpg";